import { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col, Row, Card, Accordion, Spinner, Dropdown } from "react-bootstrap";
import _ from "lodash";
import ApiUserWithdrawal from "../../../core/api/api.userWithdrawal";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import { TextField } from "@mui/material";
import { NumericFormat } from "react-number-format";
import { useLocation, useNavigate } from "react-router-dom";
import { numberRegex, tools } from "../../../core/utils/tools";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiSupplier from "../../../core/api/api.supplier";
import InsertDriveFile from "@mui/icons-material/InsertDriveFile";
import ApiAgent from "../../../core/api/api.agent";
import GlobalFormControl from "../_Components/GlobalFormControl";
import SwalMessage from "../_Components/SwalMessage";
import jalaali from "jalaali-js";
import moment from "moment-jalaali";

moment.locale("fa");
moment.loadPersian();
const userTypeList = [
  { id: "0", title: "کاربر" },
  { id: "1", title: "تامین کننده" },
  { id: "2", title: "نماینده" },
];
const sortByList = [{ value: 1, label: "زمان ایجاد" }, { value: 2, label: "زمان انجام" }]
const pageHeight = window.innerHeight;

function areAllStatusSame(arr) {
  if (!Array.isArray(arr) || arr.length === 0) return true;

  const uniqueStatuses = _.uniqBy(arr, 'status');
  return uniqueStatuses.length === 1;
}

const UserWithdrawals = () => {
  let location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const [listData, setListData] = useState({});
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
    setError,
    clearErrors,
  } = useForm({ defaultValues: { sortBy: sortByList[0] } });
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [status, setstatus] = useState([]);
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : getValues("pageSize");
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : getValues("pageNumber");
  const sortBy1 = searchParams.get("sortBy");
  const sortBy = !_.isEmpty(sortBy1) ? _.toNumber(sortBy1) : 1;
  const [companyName, setCompanyName] = useState();
  const [showCompanyName, setShowCompanyName] = useState(false);
  const [searchParamsUserTypeValue, setSearchParamsUserTypeValue] = useState();
  const userTypeValue = watch("userType");
  const [isExcel, setIsExcel] = useState(false);
  const [basketCancelStatus, setBasketCancelStatus] = useState([]);
  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const data = await ApiUserWithdrawal.getAllUserWithdrawal({
          firstName: searchParams.get("firstName"),
          lastName: searchParams.get("lastName"),
          phoneNumber: searchParams.get("phoneNumber"),
          orderPRiceOf: searchParams.get("orderPRiceOf"),
          orderPRiceTo: searchParams.get("orderPRiceTo"),
          createTime: searchParams.get("createTime"),
          userType: searchParams.get("userType"),
          companyId: searchParams.get("companyId"),
          createTimeTo: searchParams.get("createTimeTo"),
          dateSuccess: searchParams.get("dateSuccess"),
          dateSuccessTo: searchParams.get("dateSuccessTo"),
          status: _.toString(searchParams.get("status")),
          globalSearch: searchParams.get("globalSearch"),
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
          sortBy
        });
        setListData(data);
        setValue("sortBy", sortByList.find(item => item.value == sortBy))
        setValue("totalCount", data.totalCount);
        if (searchParams.get("userType") === "1") {
          setShowCompanyName(true);
          setSearchParamsUserTypeValue("1");
        } else if (searchParams.get("userType") === "2") {
          setShowCompanyName(true);
          setSearchParamsUserTypeValue("2");
        }
        const response2 = await ApiUserWithdrawal.getUserWithdrawalStatus();
        if (!_.isEmpty(response2) && !_.isEmpty(response2.data)) {
          setstatus(response2.data);
        }

        const formInputs = [
          { name: "firstName", type: "text" },
          { name: "lastName", type: "text" },
          { name: "phoneNumber", type: "text" },
          { name: "orderPRiceOf", type: "text" },
          { name: "orderPRiceTo", type: "text" },
          { name: "createTime", type: "datePicker" },
          { name: "createTimeTo", type: "datePicker" },
          { name: "dateSuccess", type: "datePicker" },
          { name: "dateSuccessTo", type: "datePicker" },
          { name: "status", type: "multiSelect", isMulti: true, data: response2.data },
          { name: "userType", type: "multiSelect", isMulti: false, data: userTypeList },
          {
            name: "companyId",
            type: "multiSelect",
            isMulti: false,
            data: companyName?.map((item) => ({
              id: item.id,
              value: item.id,
              title: item.companyName,
            })),
          },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        setValue("companyId", "");
        if (userTypeValue.value === "0") {
          setCompanyName([]);
          setValue("companyId", "");
        }
        if (userTypeValue.value === "2" || searchParamsUserTypeValue === "2") {
          const allAgents = await ApiAgent.getAllAgentsName();
          setCompanyName(allAgents);
        } else if (userTypeValue.value === "1" || searchParamsUserTypeValue === "1") {
          const suppliers = await ApiSupplier.getAllSuppliersName();
          setCompanyName(suppliers);
        }
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, [userTypeValue, searchParamsUserTypeValue]);

  const onSubmit = async (data) => {
    if (!_.isEmpty(data.orderPRiceTo) && !validateNumberOrderPRiceTo(data.orderPRiceTo)) return;
    if (!_.isEmpty(data.orderPRiceOf) && !validateNumberOrderPRiceOf(data.orderPRiceOf)) return;
    if (data.createTime && typeof data.createTime === "object") {
      data.createTime = tools.DateFormat(data.createTime);
    }
    if (data.createTimeTo && typeof data.createTimeTo === "object") {
      data.createTimeTo = tools.DateFormat(data.createTimeTo);
    }
    if (data.dateSuccess && typeof data.dateSuccess === "object") {
      data.dateSuccess = tools.DateFormat(data.dateSuccess);
    }
    if (data.dateSuccessTo && typeof data.dateSuccessTo === "object") {
      data.dateSuccessTo = tools.DateFormat(data.dateSuccessTo);
    }
    if (!_.isEmpty(data.orderPRiceOf)) data.orderPRiceOf = data.orderPRiceOf.replaceAll(",", "");
    if (!_.isEmpty(data.orderPRiceTo)) data.orderPRiceTo = data.orderPRiceTo.replaceAll(",", "");
    if (data.status?.length > 0) data.status = data.status?.map((item) => item.value);

    if (data.sortBy) data.sortBy = data.sortBy?.value
    else data.sortBy = 1
    data.userType = data.userType?.value;
    data.companyId = data.companyId?.value;
    data.status = _.toString(data.status);

    tools.setPageNumber(data, searchParams, setValue);

    if (isExcel) {
      await ApiUserWithdrawal.getAllUserWithdrawalByExcel(data).then((response) => {
        const fileBlobUrl = URL.createObjectURL(new Blob([response]));
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.id = "file" + Math.floor(Math.random() * 100);
        anchor.href = fileBlobUrl;
        anchor.download = "UserWithdrawalReport.xlsx";
        document.body.appendChild(anchor);
        anchor.click();
      });
      setIsExcel(false);
    } else {
      const apiData = await ApiUserWithdrawal.getAllUserWithdrawal(data);
      setListData(apiData);
      setValue("totalCount", apiData.totalCount);
      //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
      var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
      navigate(`/userWithdrawals?${queryString}`);
    }
  };
  function handleChangeMultiOrderStatus(value) {
    //setorderStatus( value);
    setValue("status", value);
  }
  const validateNumberOrderPRiceOf = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("orderPRiceOf", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("orderPRiceOf");
      return true;
    }
  };
  const validateNumberOrderPRiceTo = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("orderPRiceTo", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("orderPRiceTo");
      return true;
    }
    setSelectedCheckBoxes([]);
  };

  const handleChangeStatus = async (singleStatus) => {
    const selectedItems = listData?.data?.filter(item => selectedCheckBoxes.includes(item.id))
    if (!areAllStatusSame()) {
      SwalMessage({
        title: "وضعیت انتخاب شده تمامی موارد انتخاب شده باید یکسان باشند",
        iSsuccess: false,
        timer: 4000,
      });
      return
    }
    switch (singleStatus) {
      case 3:

      default:
        const paymentTime = moment().format("HH:mm")
        const today = new Date();
        const toJalaali = (date) => {
          const jDate = jalaali.toJalaali(date);
          return `${jDate.jy}/${("0" + jDate.jm).slice(-2)}/${("0" + jDate.jd).slice(-2)}`;
        };
        const formattedToday = toJalaali(today);
        let paymentDate
        if (formattedToday && typeof formattedToday === "object") {
          paymentDate =
            formattedToday.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
            "/" +
            formattedToday.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
            "/" +
            formattedToday.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
        } else {
          paymentDate = formattedToday;
        }
        if (formattedToday && typeof formattedToday === "object") {
          paymentDate = tools.DateFormat(formattedToday);
        }
        const resdata = await ApiUserWithdrawal.updateUserWithdrawalStatusInGrouping({ status: status[singleStatus].title, paymentTime, paymentDate, UserWithdrawalIds: selectedCheckBoxes })
        if (resdata.succeeded) {
          SwalMessage({
            title: "تغییرات این آیتم با موفقیت ثبت شد",
            iSsuccess: true,
          });
          const submitButton = document.getElementById("submitButton")
          submitButton.click()
        } else
          SwalMessage({
            title: resdata.message,
            iSsuccess: false,
          });
    }
  }
  return (
    <div>
      <div className={`card card-custom`}>
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت بلیط ها</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست بلیط ها</span>
          </h3>
          {/* <Dropdown className=" sticky-top " style={{ position: "fixed", top: pageHeight / 2, left: "-16px" }}>
            <Dropdown.Toggle size="sm" drop="up" variant="primary" className=" position-absolute right-0 fa-rotate-270">
              عملیات{" "}
            </Dropdown.Toggle>
            <Dropdown.Menu className="p-2">
              <Dropdown.Item className="m-0 p-0 ">
                <button
                  className="btn btn-outline-primary ml-auto btn-sm col-12 mb-2"
                  onClick={() => handleChangeStatus(status[0].id)}
                >
                  جدید
                </button>
              </Dropdown.Item>
              <Dropdown.Item className="m-0 p-0 ">
                <button
                  className="btn btn-outline-primary ml-auto btn-sm col-12 mb-2"
                  onClick={() => handleChangeStatus(status[1].id)}
                >
                  در حال پیگیری
                </button>
              </Dropdown.Item>
              <Dropdown.Item className="m-0 p-0 ">
                <button
                  className="btn btn-outline-primary ml-auto btn-sm col-12 mb-2"
                  onClick={() => handleChangeStatus(status[2].id)}
                >
                  رهاسازی
                </button>
              </Dropdown.Item>
              <Dropdown.Item className="m-0 p-0 ">
                <button
                  className="btn btn-outline-primary ml-auto btn-sm col-12 mb-2"
                  onClick={() => handleChangeStatus(status[3].id)}
                >
                  انجام شد
                </button>
              </Dropdown.Item>
              <Dropdown.Item className="m-0 p-0 ">
                <button
                  className="btn btn-outline-primary ml-auto btn-sm col-12 mb-2"
                  onClick={() => handleChangeStatus(status[4].id)}
                >
                  رد شده
                </button>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}
        </div>

        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">لیست درخواست وجوه کاربران</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست درخواست های ثبت شده</span>
          </h3>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}

              <div className="border-top pt-3">
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body>
                        <Row>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="firstName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="lastName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام خانوادگی"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>

                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="phoneNumber"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="شماره تماس"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  onInput={(e) => {
                                    if (e.target.value && (!numberRegex.test(e.target.value) || e.target.value.length > 11)) {
                                      e.target.value = getValues("accountNumber")
                                      return
                                    }
                                    onChange(e)
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2  ">
                            <Controller
                              name="status"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  placeholder="وضعیت"
                                  options={status?.map((item) => ({
                                    value: item.id,
                                    label: item.id + "-" + item.title,
                                  }))}
                                  field={field}
                                  onChange={handleChangeMultiOrderStatus}
                                  isMulti
                                />
                              )}
                            />
                          </Col>

                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="orderPRiceOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="مبلغ سفارش از"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  error={!!errors.orderPRiceOf}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberOrderPRiceOf(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                  type="search"
                                />
                              )}
                            />
                            {errors.orderPRiceOf && (
                              <div className="text-small-1 text-danger"> {errors.orderPRiceOf.message}</div>
                            )}
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="orderPRiceTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="مبلغ سفارش تا"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  error={!!errors.orderPRiceTo}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberOrderPRiceTo(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                  type="search"
                                />
                              )}
                            />
                            {errors.orderPRiceTo && (
                              <div className="text-small-1 text-danger"> {errors.orderPRiceTo.message}</div>
                            )}
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="createTime"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  placeholder="زمان ایجاد از"
                                  onChange={(date) => {
                                    var createTimeTo = getValues("createTimeTo");
                                    onChange(date);
                                    if (!createTimeTo || (date?.toDate && date?.toDate()?.getTime() > new Date(createTimeTo).getTime())) {
                                      // Set the value of createTimeTo to the same as createTimeTo
                                      setValue("createTimeTo", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="createTimeTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  onChange={onChange}
                                  placeholder="زمان ایجاد تا"
                                />
                              )}
                            />
                          </Col>

                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="dateSuccess"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  placeholder="تاریخ انجام از"
                                  onChange={(date) => {
                                    var dateSuccessTo = getValues("dateSuccessTo");
                                    onChange(date);
                                    if (
                                      !dateSuccessTo ||
                                      (date?.toDate && date?.toDate()?.getTime() > new Date(dateSuccessTo).getTime())
                                    ) {
                                      // Set the value of dateSuccessTo to the same as dateSuccessTo
                                      setValue("dateSuccessTo", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="dateSuccessTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  onChange={onChange}
                                  placeholder="تاریخ انجام تا"
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="userType"
                              control={control}
                              rules={{}}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  placeholder="نوع حساب"
                                  options={userTypeList?.map((item) => ({
                                    value: item.id,
                                    label: item.title,
                                  }))}
                                  value={field.value || null}
                                  onChange={(val) => {
                                    field.onChange(val);
                                    if (val?.value === "2" || val?.value === "1") setShowCompanyName(true);
                                    else setShowCompanyName(false);
                                  }}
                                />
                              )}
                            />
                          </Col>
                          {showCompanyName && (
                            <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                              <Controller
                                name="companyId"
                                control={control}
                                rules={{}}
                                render={({ field }) => (
                                  <SelectComponent
                                    className="mt-5"
                                    placeholder="شرکت"
                                    options={companyName?.map((item) => ({
                                      value: item.id,
                                      label: item.companyName,
                                    }))}
                                    field={field}
                                  />
                                )}
                              />
                            </Col>
                          )}
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2  ">
                            <Controller
                              name="sortBy"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  placeholder="مرتب سازی"
                                  options={sortByList}
                                  field={field}
                                  noClear
                                />
                              )}
                            />
                          </Col>
                        </Row>

                        <Row className="pt-3">
                          <Col className="tb-reponsive px-2 ">
                            <Button
                              variant="success"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                setIsExcel(false);
                              }}
                            >
                              {(isSubmitting && !isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>

                            <Button
                              variant="light-danger ml-2"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                setIsExcel(false);
                                tools.handleResetAdvanceSearchBox(watch, reset);
                                setCompanyName([]);
                                setShowCompanyName(false);
                              }}
                            >
                              {(isSubmitting && !isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                            <Button
                              className="ml-2"
                              variant="info"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                setIsExcel(true);
                              }}
                            >
                              {(isSubmitting && isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <InsertDriveFile /> فایل اکسل
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid
                  data={listData}
                  setSelectedCheckBoxes={setSelectedCheckBoxes}
                  selectedCheckBoxes={selectedCheckBoxes}
                />
              </Col>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default UserWithdrawals;
